<template>
  <div class="grower-calculator">
    <CampaignCalculator
      :valueCalculator="valueCalculator"
      :backgroundTheme="backgroundTheme"
      :brand="brand"
    />
  </div>
</template>
<script>
import CampaignCalculator from '@/components/CampaignCalculator';

export default {
  components: {
    CampaignCalculator
  },
  data() {
    return {
      backgroundTheme: 'light',
      brand: 'microessentials',
      valueCalculator: {
        contentType: 'valueCalculator',
        id: 'gYM5pbuRHP2gAhGiHhyIc',
        title: "Calculate What You're Missing",
        description:
          'If you’re using a commodity fertilizer, you’re leaving money on the table. Use our calculator to see just how much.',
        fertilizers: [
          {
            contentType: 'valueCalculatorFertilizer',
            id: '26kjNMmI0L74CMzUgmLlzy',
            name: 'DAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '4rJcqK1xXZARuvcTxljwrz',
              name: 'MicroEssentials SZ®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '2kuI51EGbA89xR2UYaeOrq',
                title: 'MicroEssentials SZ Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/2kuI51EGbA89xR2UYaeOrq/eb32f44d1e7f3c64b3aed3ef9af827b1/sz.png',
                contentType: 'image/png',
                height: 38,
                width: 66
              },
              logo: {
                id: '7LHcfSf1edRGZKPW6J15bH',
                title: 'MicroEssentialsSZ 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/7LHcfSf1edRGZKPW6J15bH/af2d5d8c6c608843bf3b08f0efe92a9b/MicroEssentialsSZ_400.png',
                contentType: 'image/png',
                height: 79,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-sz',
              specAndSafetyDescription:
                'MicroEssentials SZ® offers all the advanced crop nutrition benefits of MicroEssentials® uniform balance of nitrogen, phosphorus and sulfur with the addition of zinc (12-40-10S-1Zn) to increase the yield and nutritional quality of certain crop types.\n',
              zinc: 0.01
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1EBESGRbNpDWu8PBaz1Lcs',
              crop: 'Corn',
              priceUnit: 'bu',
              minimumPrice: 2.5,
              maximumPrice: 8.5,
              defaultPrice: 5,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 5,
            maximumYield: 15,
            defaultYield: 8.8,
            yieldInterval: 0.1,
            cost: 12,
            disclaimer:
              '*Results based on 70 lbs of P₂O₅ applied and a premium of $80/ton over DAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 46,
            nitrogen: 18
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '2m99dH2fK1smiwiFzgnxQn',
            name: 'MAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '4rJcqK1xXZARuvcTxljwrz',
              name: 'MicroEssentials SZ®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '2kuI51EGbA89xR2UYaeOrq',
                title: 'MicroEssentials SZ Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/2kuI51EGbA89xR2UYaeOrq/eb32f44d1e7f3c64b3aed3ef9af827b1/sz.png',
                contentType: 'image/png',
                height: 38,
                width: 66
              },
              logo: {
                id: '7LHcfSf1edRGZKPW6J15bH',
                title: 'MicroEssentialsSZ 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/7LHcfSf1edRGZKPW6J15bH/af2d5d8c6c608843bf3b08f0efe92a9b/MicroEssentialsSZ_400.png',
                contentType: 'image/png',
                height: 79,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-sz',
              specAndSafetyDescription:
                'MicroEssentials SZ® offers all the advanced crop nutrition benefits of MicroEssentials® uniform balance of nitrogen, phosphorus and sulfur with the addition of zinc (12-40-10S-1Zn) to increase the yield and nutritional quality of certain crop types.\n',
              zinc: 0.01
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1EBESGRbNpDWu8PBaz1Lcs',
              crop: 'Corn',
              priceUnit: 'bu',
              minimumPrice: 2.5,
              maximumPrice: 8.5,
              defaultPrice: 5,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 5,
            maximumYield: 15,
            defaultYield: 7.2,
            yieldInterval: 0.1,
            cost: 15,
            disclaimer:
              '*Results based on 70 lbs of P₂O₅ applied and a premium of $70/ton over MAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company. ',
            research: [Array],
            phosphorus: 52,
            nitrogen: 11
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: 'r7ifsdAsVirk2xEiXxCxc',
            name: 'DAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: 'aUnUxPTsGbECOOsOkedk3',
              name: 'MicroEssentials S10®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '3r6TVBMa0nPCd7Qm50Bbst',
                title: 'MicroEssentials S10 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/3r6TVBMa0nPCd7Qm50Bbst/4ae21cee1efcd94e0a224afefbe830a7/s10.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: 'IXKRPzcMYkJAHqaVKNYMG',
                title: 'MicroEssentialsS10 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/IXKRPzcMYkJAHqaVKNYMG/91ba38f5a7a363ba3815be94a44b4f4a/MicroEssentialsS10_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-s10',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-40-0-10S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1djh8RxAKZt15ZeIEWlQgs',
              crop: 'Soybean',
              priceUnit: 'bu',
              minimumPrice: 6,
              maximumPrice: 16,
              defaultPrice: 11,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 5,
            defaultYield: 2.3,
            yieldInterval: 0.1,
            cost: 4.76,
            disclaimer:
              '*Results based on 40 lbs P₂O₅ applied and a premium of $30/ton over DAP. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 46,
            nitrogen: 18
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: 'SSHPaHaBT5OMME7M1aLnF',
            name: 'MAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: 'aUnUxPTsGbECOOsOkedk3',
              name: 'MicroEssentials S10®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '3r6TVBMa0nPCd7Qm50Bbst',
                title: 'MicroEssentials S10 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/3r6TVBMa0nPCd7Qm50Bbst/4ae21cee1efcd94e0a224afefbe830a7/s10.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: 'IXKRPzcMYkJAHqaVKNYMG',
                title: 'MicroEssentialsS10 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/IXKRPzcMYkJAHqaVKNYMG/91ba38f5a7a363ba3815be94a44b4f4a/MicroEssentialsS10_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-s10',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-40-0-10S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1djh8RxAKZt15ZeIEWlQgs',
              crop: 'Soybean',
              priceUnit: 'bu',
              minimumPrice: 6,
              maximumPrice: 16,
              defaultPrice: 11,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 5,
            defaultYield: 2.5,
            yieldInterval: 0.1,
            cost: 6.86,
            disclaimer:
              '*Results based on 40 lbs P₂O₅ applied and a premium of $20/ton over MAP. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 52,
            nitrogen: 11
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: 'lOX1TFajBCGUNfoRpgx6R',
            name: 'MAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: 'aUnUxPTsGbECOOsOkedk3',
              name: 'MicroEssentials S10®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '3r6TVBMa0nPCd7Qm50Bbst',
                title: 'MicroEssentials S10 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/3r6TVBMa0nPCd7Qm50Bbst/4ae21cee1efcd94e0a224afefbe830a7/s10.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: 'IXKRPzcMYkJAHqaVKNYMG',
                title: 'MicroEssentialsS10 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/IXKRPzcMYkJAHqaVKNYMG/91ba38f5a7a363ba3815be94a44b4f4a/MicroEssentialsS10_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-s10',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-40-0-10S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1EBESGRbNpDWu8PBaz1Lcs',
              crop: 'Corn',
              priceUnit: 'bu',
              minimumPrice: 2.5,
              maximumPrice: 8.5,
              defaultPrice: 5,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 10,
            defaultYield: 4.7,
            yieldInterval: 0.1,
            cost: 10.69,
            disclaimer:
              '*Results based on 80 lbs P₂O₅ applied and a premium of $20/ton over MAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 52,
            nitrogen: 11
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '1QJLuOGwZrDLu7nnzgqVsl',
            name: 'DAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: 'aUnUxPTsGbECOOsOkedk3',
              name: 'MicroEssentials S10®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '3r6TVBMa0nPCd7Qm50Bbst',
                title: 'MicroEssentials S10 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/3r6TVBMa0nPCd7Qm50Bbst/4ae21cee1efcd94e0a224afefbe830a7/s10.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: 'IXKRPzcMYkJAHqaVKNYMG',
                title: 'MicroEssentialsS10 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/IXKRPzcMYkJAHqaVKNYMG/91ba38f5a7a363ba3815be94a44b4f4a/MicroEssentialsS10_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-s10',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-40-0-10S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1EBESGRbNpDWu8PBaz1Lcs',
              crop: 'Corn',
              priceUnit: 'bu',
              minimumPrice: 2.5,
              maximumPrice: 8.5,
              defaultPrice: 5,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 10,
            defaultYield: 5.4,
            yieldInterval: 0.1,
            cost: 9,
            disclaimer:
              '*Results based on 70 lbs of P₂O₅ applied and a premium of $30/ton over DAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 46,
            nitrogen: 18
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '6Nw7y0evBy1Ni6d6MLE3Qu',
            name: 'MAP Blend',
            formula: {
              contentType: 'performanceProductFormula',
              id: '6ulBmZTSOMkBSEzYvPn5yb',
              name: 'MicroEssentials S15®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '48fYeBrNBUCFPT94jvUtzl',
                title: 'MicroEssentials S15 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/48fYeBrNBUCFPT94jvUtzl/d80536d69bec3a813817792a14fb8c19/s15.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: '2GaUAD1EmyLUUfHtDlhiF',
                title: 'MicroEssentialsS15 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/2GaUAD1EmyLUUfHtDlhiF/e5aa2fa9a3e156f374bcb285695269ea/MicroEssentialsS15_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.13,
              phosphorus: 0.33,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.075,
              sulfate: 0.075,
              nutrients: [Array],
              slug: 'microessentials-s15',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-33-0-15S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1hUWrxrOqtrXpwErGFM3GB',
              crop: 'Canola',
              priceUnit: 'bu',
              minimumPrice: 8,
              maximumPrice: 18,
              defaultPrice: 13,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1,
            maximumYield: 5,
            defaultYield: 2.5,
            yieldInterval: 0.1,
            cost: 3.5,
            disclaimer:
              '*Results based on 40 lbs of P₂O₅ applied and a premium of $20/ton over MAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 52,
            nitrogen: 11
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '61PXipKfPTuKTm1AjDz41D',
            name: 'MAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: '6ulBmZTSOMkBSEzYvPn5yb',
              name: 'MicroEssentials S15®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '48fYeBrNBUCFPT94jvUtzl',
                title: 'MicroEssentials S15 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/48fYeBrNBUCFPT94jvUtzl/d80536d69bec3a813817792a14fb8c19/s15.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: '2GaUAD1EmyLUUfHtDlhiF',
                title: 'MicroEssentialsS15 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/2GaUAD1EmyLUUfHtDlhiF/e5aa2fa9a3e156f374bcb285695269ea/MicroEssentialsS15_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.13,
              phosphorus: 0.33,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.075,
              sulfate: 0.075,
              nutrients: [Array],
              slug: 'microessentials-s15',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-33-0-15S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '1nqKIDmY4NJtBaAIwnYkfX',
              crop: 'Wheat',
              priceUnit: 'bu',
              minimumPrice: 3,
              maximumPrice: 13,
              defaultPrice: 8,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 2,
            maximumYield: 6,
            defaultYield: 3,
            yieldInterval: 0.1,
            cost: 9.33,
            disclaimer:
              '*Results based on 40 lbs P₂O₅ applied and a premium of $20/ton over MAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 52,
            nitrogen: 11
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '1w2jiuGJwfZ5njzQgBmjIS',
            name: 'DAP',
            formula: {
              contentType: 'performanceProductFormula',
              id: 'aUnUxPTsGbECOOsOkedk3',
              name: 'MicroEssentials S10®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '3r6TVBMa0nPCd7Qm50Bbst',
                title: 'MicroEssentials S10 Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/3r6TVBMa0nPCd7Qm50Bbst/4ae21cee1efcd94e0a224afefbe830a7/s10.png',
                contentType: 'image/png',
                height: 38,
                width: 78
              },
              logo: {
                id: 'IXKRPzcMYkJAHqaVKNYMG',
                title: 'MicroEssentialsS10 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/IXKRPzcMYkJAHqaVKNYMG/91ba38f5a7a363ba3815be94a44b4f4a/MicroEssentialsS10_400.png',
                contentType: 'image/png',
                height: 74,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-s10',
              specAndSafetyDescription:
                'Formulated with nitrogen, phosphorus, and sulfur, MicroEssentials S10® offers a specialized nutrient ratio (12-40-0-10S) that’s favorable for the unique needs of specific crops and soil conditions.',
              zinc: 0
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: '5IvYeQanFFme4m4fnjFsdK',
              crop: 'Cotton',
              priceUnit: 'lbs',
              minimumPrice: 0.5,
              maximumPrice: 1,
              defaultPrice: 0.7,
              priceInterval: 0.05
            },
            yieldUnit: 'acre',
            minimumYield: 50,
            maximumYield: 100,
            defaultYield: 60,
            yieldInterval: 5,
            cost: 7.94,
            disclaimer:
              '*Results based on 50 lbs P₂O₅ applied and a premium of $30/ton over DAP and balanced for total N. This example reflects typical use rates. Actual yield results and local pricing may vary. Expected yield advantage based on multi-year research conducted by The Mosaic Company.',
            research: [Array],
            phosphorus: 46,
            nitrogen: 18
          },
          {
            contentType: 'valueCalculatorFertilizer',
            id: '6tKvcrL1d1kUCvgKQby61R',
            name: 'DAP Blend',
            formula: {
              contentType: 'performanceProductFormula',
              id: '4rJcqK1xXZARuvcTxljwrz',
              name: 'MicroEssentials SZ®',
              dataSheet: [Object],
              description: undefined,
              directionsForUse: undefined,
              ghsProductLabels: [Object],
              icon: {
                id: '2kuI51EGbA89xR2UYaeOrq',
                title: 'MicroEssentials SZ Logo',
                description: undefined,
                url: '//images.ctfassets.net/3jf1t80tlft4/2kuI51EGbA89xR2UYaeOrq/eb32f44d1e7f3c64b3aed3ef9af827b1/sz.png',
                contentType: 'image/png',
                height: 38,
                width: 66
              },
              logo: {
                id: '7LHcfSf1edRGZKPW6J15bH',
                title: 'MicroEssentialsSZ 400',
                description: undefined,
                url:
                  '//images.ctfassets.net/3jf1t80tlft4/7LHcfSf1edRGZKPW6J15bH/af2d5d8c6c608843bf3b08f0efe92a9b/MicroEssentialsSZ_400.png',
                contentType: 'image/png',
                height: 79,
                width: 240
              },
              nitrogen: 0.12,
              phosphorus: 0.4,
              potassiumOxide: 0,
              safetyDataSheet: [Object],
              sulfur: 0.05,
              sulfate: 0.05,
              nutrients: [Array],
              slug: 'microessentials-sz',
              specAndSafetyDescription:
                'MicroEssentials SZ® offers all the advanced crop nutrition benefits of MicroEssentials® uniform balance of nitrogen, phosphorus and sulfur with the addition of zinc (12-40-10S-1Zn) to increase the yield and nutritional quality of certain crop types.\n',
              zinc: 0.01
            },
            crop: {
              contentType: 'valueCalculatorCrop',
              id: 'aER9t8VvLh7yRWhsjzpGZ',
              crop: 'Rice',
              priceUnit: 'bu',
              minimumPrice: 4,
              maximumPrice: 8,
              defaultPrice: 6,
              priceInterval: 0.1
            },
            yieldUnit: 'acre',
            minimumYield: 1.5,
            maximumYield: 5.5,
            defaultYield: 2.5,
            yieldInterval: 0.1,
            cost: 7.65,
            disclaimer:
              '*Yield response of 2.5 bu/ac over DAP blend treatments based on results obtained in the AgriFacts® above.  Results based on 80 lbs of P₂O₅ and balanced for total N, S and Zn applied and a premium of $90/ton over DAP.  This example reflects typical use rates.  Actual Yield results and local pricing may vary.',
            research: [Array],
            phosphorus: 46,
            nitrogen: 18
          }
        ]
      }
    };
  }
};
</script>
